const updateQueryParams = (key, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);

  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.pushState({}, "", newUrl);
};

export default updateQueryParams;
